import { Routes, Route } from 'react-router-dom'
import MainLayout from '@layouts/MainLayout'
import Home from '@pages/Home'
import WhoWeAre from '@pages/WhoWeAre'
import OurServices from '@pages/OurServices'
import GetInTouch from '@pages/GetInTouch'
import ServiceRequests from '@pages/ServiceRequests'

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="who-we-are" element={<WhoWeAre />} />
        <Route path="our-services" element={<OurServices />} />
        <Route path="get-in-touch" element={<GetInTouch />} />
        <Route path="service-requests" element={<ServiceRequests />} />
      </Route>
    </Routes>
  )
}

export default App
